import React, { Component } from "react";
import { Accessor, ColorX } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import VStack from "./VStack";

/**
 * @augments {Component<Props, State>}
 */
class Backdrop extends Component {

  static propTypes = {
    open: PropsType.bool,
    noBG: PropsType.bool,
    zIndex: PropsType.number,
    clickThrough: PropsType.bool,
    noBlur: PropsType.bool,
  }

  static defaultProps = {
    open: false,
    noBG: false,
    zIndex: 1000,
    clickThrough: false,
    noBlur: false
  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates();
    document.addEventListener("mousedown", this.clickOutSide, false);
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(Backdrop.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    if(this.mousedownEvent) this.mousedownEvent.remove();
    this.setState = (state, callback) => {
      return;
    };
  }

  shouldComponentUpdate(nextProps, nextState){
    let propIdentical = Accessor.IsIdentical(nextProps, this.props, Object.keys(Backdrop.defaultProps));
    let stateIdentical = Accessor.IsIdentical(nextState, this.state, null);
    if(propIdentical && stateIdentical){
      return false;
    }
    return true;
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  clickOutSide = (e) => {
    let {onClickBackground, open} = this.props;
    if (open && this.ref && !this.ref.contains(e.target)) {
      onClickBackground?.(e);
    }
  }

  render(){
    let {open, children, noBG, zIndex, clickThrough, noBlur} = this.props;
    
    return (
      <div style={{
        width: "100%", 
        height: "100%", 
        zIndex: zIndex,
        background: ColorX.CSS("pureDark", noBG ? 0 : 0.5),
        position: "absolute",
        top: 0,
        left: 0,
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        visibility: open ? "visible" : "hidden",
        overflow: "hidden",
        pointerEvents: clickThrough ? "none" : undefined
      }}>
        {!noBlur && <VStack fullWidth fullHeight position="absolute" zIndex={-1}
          style={{backdropFilter: "blur(1px)"}}/>}
        {open &&
          <div style={{
            pointerEvents: "visible", 
            width: clickThrough ? "fit-content" : "100%", 
            height: clickThrough ? "fit-content" : "100%",
            justifyContent: "center",
            alignItems: "center",
            display: "flex"
          }}
            ref={e => this.ref = e}>
            {children}
          </div>}
      </div>
    );
  }

}

export default Backdrop;
